<template>
  <div>
    <template v-if="table">
      <v-toolbar class="mb-2" color="transparent" flat v-if="header">
        <v-toolbar-title class="color-262626 font-weight-regular title">
          <slot name="header" :data="data" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
          <v-text-field
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            placeholder="Search"
            dense
            outlined
            :loading="loading"
            @input="loading = true"
          ></v-text-field>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="tableHeader"
        :items="data.results"
        :dense="dense"
        :items-per-page.sync="itemsPerPage"
        :page.sync="currentPage"
      >
        <template #item.fullName="{ item }">{{ `${item.first_name} ${item.last_name}` }}</template>
        <template #item.created_at="{ item }">
          {{ moment(item.created_at).format("YYYY MMM DD, hh:mm A") }}
        </template>
        <template #item.avatar="{ item }">
          <v-avatar :size="dense ? 32 : 48" class="my-1">
            <v-img :src="item.avatar"></v-img>
          </v-avatar>
        </template>
        <template #item.button="{ item }">
          <v-btn
            class="text-capitalize"
            depressed
            small
            outlined
            color="#FF347C"
            @click="$emit('edit', item)"
            >Edit</v-btn
          >
        </template>
        <template #item.switch="{ item }" class="text-right">
          <v-row justify="center">
            <v-switch
              v-model="item.ready"
              color="#FF347C"
              :readonly="$store.state.profile.role === 'EDITOR'"
              @change="$emit('switch', { value: $event, item })"
            ></v-switch>
          </v-row>
        </template>
        <template #item.is_active="{ item }" class="text-right">
          <v-row justify="center">
            <v-switch
              v-model="item.is_active"
              color="#FF347C"
              @change="$emit('activeChanged', { value: $event, item })"
            ></v-switch>
          </v-row>
        </template>
        <template #item.remove="{ item }">
          <v-btn
            class="white--text"
            width="24"
            height="24"
            depressed
            fab
            :disabled="$store.state.profile.role === 'EDITOR'"
            color="#29284c"
            @click="$emit('remove', item)"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </template>
        <template #item.edit_email="{ item }">
          <email-edit-dialog :user="item" :key="item.uuid" />
        </template>
        <template #item.edit_password="{ item }">
          <password-edit-dialog :user="item" :key="item.uuid" />
        </template>
      </v-data-table>
    </template>
    <v-data-iterator
      v-else
      :items="data.results"
      :items-per-page.sync="itemsPerPage"
      :footer-props="{
        'items-per-page-options': [-1],
        'disable-items-per-page': true,
      }"
      :class="{ 'mr-12 ml-12': !$vuetify.breakpoint.xs }"
      :page.sync="currentPage"
    >
      <template v-slot:header v-if="header">
        <v-container>
          <v-row class="mb-2" color="transparent" flat>
            <span class="color-262626 font-weight-regular title">
              <slot name="header" :data="data" />
            </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                v-model="search"
                hide-details
                append-icon="mdi-magnify"
                placeholder="Search"
                dense
                height="35"
                outlined
                :loading="loading"
                style="background-color: white"
                @input="loading = true"
              ></v-text-field>
            </div>
          </v-row>
        </v-container>
      </template>

      <template v-slot:default="props">
        <v-row :justify="autoCard ? 'center' : 'start'">
          <v-col
            v-for="(item, index) in props.items"
            :key="index"
            :cols="autoCard ? 'auto' : 12"
            :sm="autoCard ? 'auto' : 6"
            :md="autoCard ? 'auto' : 4"
            :lg="autoCard ? 'auto' : onlyThree ? 4 : 3"
          >
            <slot name="card" :item="item" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>
<script>
import moment from "moment";
import { debounce } from "debounce";
import EmailEditDialog from "@/components/EmailEditDialog.vue";
import PasswordEditDialog from "@/components/PasswordEditDialog.vue";

export default {
  components: {
    EmailEditDialog,
    PasswordEditDialog,
  },
  props: {
    getter: {
      type: Function,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    header: {
      required: false,
      type: Boolean,
      default: false,
    },
    table: {
      type: Boolean,
      required: false,
      default: false,
    },
    tableHeader: {
      type: Array,
      default: () => [],
      required: false,
    },
    autoCard: {
      type: Boolean,
      default: false,
      required: false,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlyThree: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      itemsPerPage: 4,
      currentPage: 1,
      data: {
        results: [],
      },
      moment,
      search: "",
      loading: false,
    };
  },
  methods: {
    addResult(e) {
      this.data.results.push(e);
      this.data.count++;
    },
    removeResult(e) {
      this.data.results.splice(this.data.results.indexOf(e), 1);
      this.data.count--;
    },
    async pagination() {
      // pagination Code
      const count = this.data.results.length;
      if (count) {
        let pages = (count - 1) / this.itemsPerPage;
        if (this.currentPage > pages) {
          if (this.data.next) {
            try {
              const response = await this.getter({
                ...this.params,
                offset: this.data.results.length,
                limit: this.itemsPerPage,
              });
              response.data.results = [...this.data.results, ...response.data.results];
              this.data = response.data;
            } catch (error) {
              //eslint-disable-next-line
              console.log(error);
            }
          }
        }
      }
    },
    async getInitialData() {
      try {
        let newParams = { ...this.params };
        newParams.search = this.search;
        newParams.limit = this.params.limit * 2;
        newParams.offset = 0;
        const response = await this.getter(newParams);
        this.data = response.data;
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
  },
  async created() {
    if (this.table) {
      this.itemsPerPage = 5;
    }
    this.getInitialData();
  },
  watch: {
    currentPage() {
      this.pagination();
    },
    itemsPerPage() {
      this.pagination();
    },
    search: debounce(function () {
      this.getInitialData();
      this.loading = false;
    }, 200),
  },
};
</script>
